export const SUI_CRED_METADATA_ID = '0x54010e628ce809f27303c4ac10ddfd36205b2f9d4e0cc112a57c21207f9401cf'
export const SUI_CRED_SELL_CONFIG = '0x0923da38ae3ca88b2eac976f35234831e6c45fbaa03c226eec5858cc69158694'

export const SUI_NATIVE_DECIMALS = 1e9
export const SUI_CRED_DECIMALS = 1e6
